module.exports = __webpack_public_path__ + "img/logo_blue.fa14d206.png";